import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=75cbbf60&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"
import style0 from "./IndexPage.vue?vue&type=style&index=0&id=75cbbf60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cbbf60",
  null
  
)

export default component.exports